import { LogoIcon } from './SvgLoader'

export default function Ufo() {
    return (
        <div id="ufo-flight" className="ufo-flight active">
            <div className="ufo-flight__logo">
                <LogoIcon />
            </div>
        </div>
    )
}
